import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter } from "react-router-dom";

import { AppThemeProvider } from "@/components/ui";
import {
  FeatureFlagsProvider,
} from "@/lib/feature-flags/FeatureFlagsProvider";
import { isLaunchDarklyConfigured } from "@/lib/feature-flags/launchdarkly-config";
import { LaunchDarklyProvider } from "@/providers/LaunchDarklyProvider";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

interface AppProvidersProps {
  children: React.ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <LaunchDarklyProvider>
        <FeatureFlagsProvider launchDarklyEnabled={isLaunchDarklyConfigured()}>
          {/* Hash routes live in location.hash; deploy prefix is window.pathname (Vite base), not Router basename. */}
          <HashRouter>
            <AppThemeProvider>{children}</AppThemeProvider>
          </HashRouter>
        </FeatureFlagsProvider>
      </LaunchDarklyProvider>
    </QueryClientProvider>
  );
}
